// client/src/context/cognitive/cognitiveReducer.js

const cognitiveReducer = (state, { type, payload }) => {
  switch (type) {
    // Loading & Error
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: payload,
        error: null
      };
    
    case 'SET_ERROR':
      return {
        ...state,
        error: payload,
        isLoading: false
      };
    
    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null
      };

    // Text-to-Speech
    case 'SET_CURRENT_AUDIO':
      return {
        ...state,
        currentAudio: payload,
        isLoading: false
      };
    
    case 'SET_PLAYING':
      return {
        ...state,
        isPlaying: payload
      };
    
    case 'SET_PAUSED':
      return {
        ...state,
        isPaused: payload
      };
    
    case 'SET_MUTED':
      return {
        ...state,
        isMuted: payload
      };
    
    case 'SET_VOLUME':
      return {
        ...state,
        currentVolume: payload
      };
    
    case 'SET_VOICE':
      return {
        ...state,
        currentVoice: payload
      };
    
    case 'SET_LANGUAGE':
      return {
        ...state,
        currentLanguage: payload
      };
    
    case 'STOP_AUDIO':
      return {
        ...state,
        currentAudio: null,
        isPlaying: false,
        isPaused: false
      };

    // Speech-to-Text
    case 'SET_RECORDING':
      return {
        ...state,
        isRecording: payload
      };
    
    case 'SET_AUDIO_BLOB':
      return {
        ...state,
        audioBlob: payload
      };
    
    case 'SET_TRANSCRIBED_TEXT':
      return {
        ...state,
        transcribedText: payload,
        isLoading: false
      };
    
    case 'SET_RECORDING_DURATION':
      return {
        ...state,
        recordingDuration: payload
      };
    
    case 'CLEAR_TRANSCRIPTION':
      return {
        ...state,
        transcribedText: '',
        audioBlob: null,
        recordingDuration: 0
      };

    // Reset
    case 'RESET_COGNITIVE_STATE':
      return {
        ...state,
        currentAudio: null,
        isPlaying: false,
        isPaused: false,
        isRecording: false,
        transcribedText: '',
        audioBlob: null,
        error: null
      };

    default:
      return state;
  }
};

export default cognitiveReducer;